<template>
	<footer>
		<slot></slot>
		<p>
			Refer to the full Prescribing Information, available at <a target="_blank" href="https://www.rxabbvie.com/pdf/venclexta.pdf">rxabbvie.com</a>.
		</p>
	</footer>
</template>
<style scoped>
footer {
	color: rgba(222,235,221,1);
	font-weight: bold;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 1.5rem;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	min-height: 30px;
	padding-bottom: 6px;
	position: relative;
}

	footer:deep img {
		position: absolute;
		top: -8px;
		left: 18px;
	}

	footer a {
		color: rgba(36, 182, 162, 1);
	}
</style>